var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.083 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.083 4c2.646 0 4.902 1.164 6.634 2.516s3.01 2.948 3.724 3.949c.25.351.642.838.642 1.535s-.391 1.184-.642 1.535c-.713 1-1.991 2.596-3.724 3.95C16.985 18.834 14.729 20 12.083 20s-4.903-1.164-6.634-2.516c-1.733-1.353-3.011-2.948-3.725-3.949-.25-.351-.641-.838-.641-1.535s.39-1.184.641-1.535c.714-1 1.992-2.596 3.725-3.95C7.18 5.166 9.437 4 12.083 4m0 2c-2.043 0-3.876.9-5.403 2.093-1.525 1.19-2.674 2.618-3.327 3.533-.078.11-.136.19-.183.262q-.05.074-.07.112.02.038.07.112c.047.071.105.152.183.262.653.915 1.802 2.343 3.327 3.533C8.207 17.1 10.04 18 12.083 18s3.875-.9 5.402-2.093c1.525-1.19 2.675-2.618 3.327-3.533.078-.11.136-.19.184-.262q.048-.074.07-.112-.022-.038-.07-.112c-.048-.071-.105-.152-.184-.262-.652-.915-1.802-2.343-3.327-3.533C15.958 6.9 14.126 6 12.083 6",
    clipRule: "evenodd"
  })));
};
export default Svg24;